<template>
  <div class="w-full">
    <div class="flex items-center px-4 py-4 flex-wrap">
      <div class="w-6/12">
        Payments Trend
      </div>
    </div>
    <apexchart class="w-full" type="line" height="250" :options="chartOptions" :series="series"></apexchart>
    <div class="ml-4 mt-2">
      <div class="inline-flex items-center mr-3">
        <span class="inline-block w-4 h-4 rounded-[50px] bg-secondary-yellow mr-2"></span>
        Total Trips
      </div>
      <div class="inline-flex items-center">
        <span class="inline-block w-4 h-4 rounded-[50px] bg-secondary-orange mr-2"></span>
        Total Payments
      </div>
    </div>
    <filter-trend :show-modal="showFilterModal" @close-modal="showFilterModal = false" />
  </div>
</template>

<script>
import FilterTrend from '../modals/FilterTrend.vue';
export default {
  props: {
    paymentTrend: {
      type: Array
    },
    setSearchQuery: {
      type: Function
    }
  },
  components: {
    FilterTrend
  },
  watch: {
    // paymentTrend() {
    //   this.setSeries()
    // },
    paymentTrend: {
      immediate: true,
      handler(newData) {
        
        this.setSeries(newData);
        setTimeout(() =>{
          
        }, )
      },
    },
  },
  // mounted() {
  //   this.setSeries()
  // },
  methods: {
    changeValue(event) {
      this.setSearchQuery(event.target.value);
    },
    setSeries() {
      let cloneChartOpt = {
        chart: {
          toolbar: { show: false },
        },
        stroke: {
          curve: "straight",
          dashArray: [0, 8],
          width: [2, 2],
        },
        grid: {
          borderColor: "#e7e7e7",
        },
        legend: {
          show: false,
        },
        colors: ["#D72638", "rgb(227,181,5)", "#546E7A", "#E91E63", "#FF9800"],
        fill: {
          type: "solid",
          opacity: 1,
          gradient: {
            shade: "dark",
            inverseColors: false,
            gradientToColors: ["#7367F0", "#b8c2cc"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 50, 50],
          },
        },
        markers: {
          size: 0,
          hover: {
            size: 3,
          },
        },
        xaxis: {
          labels: {
            style: {
              cssClass: "text-cloudenly-primary-main fill-current",
            },
          },
          axisTicks: {
            show: true,
          },
          categories: ['mon'],
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          title: {
            text: "Amount",        //  <-- Y-axis label text
            rotate: -90,
            offsetX: 0,
            offsetY: 0,
            style: {
              color: "#333",      // customize text color
              fontSize: "14px",   // customize font size
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-title",
            },
          },
          tickAmount: 5,
          labels: {
            style: {
              cssClass: "text-cloudenly-primary-main fill-current",
            },
            formatter: function (val) {
              return val < 0 ? (val / 1000).toFixed(1) + "k" : val;
            },
          },
        },
        tooltip: {
          x: { show: true },
        },
      }
      let yTitles = this.paymentTrend.map((item) => {
        return item.label
      })
      cloneChartOpt.xaxis.categories = yTitles
      this.chartOptions = cloneChartOpt

      this.series = [
        {
          name: "Payments Trend",
          data: this.getCollections,
        },
        {
          name: "Trips Trend",
          data: this.getTransaction,
        }
      ]
    }
  },
  computed: {
    getCollections() {
      return this.paymentTrend.map((item) => {
        return item?.tip == null ? 0 : item?.tip
      })
    },
    getTransaction() {
      return this.paymentTrend.map((item) => {
        return item?.earning == null ? 0 : item?.earning
      })
    }
  },
  data() {
    return {
      showFilterModal: false,
      startDate: "",
      enddate: "",
      series: [],
      chartOptions: {},
    };
  },
};
</script>

<style lang="scss" scoped></style>
